const isTest = process.env.NODE_ENV === 'test'
const isServer = typeof window === 'undefined'

const shouldLoadPolyfill = !isTest && !isServer

if (shouldLoadPolyfill) {
  if (!Array.prototype.at) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.at = function arrayAt(index: number) {
      const len = this.length
      const relativeIndex = index >= 0 ? index : len + index

      if (relativeIndex < 0 || relativeIndex >= len) {
        return undefined
      }

      return this[relativeIndex]
    }
  }

  if (!String.prototype.at) {
    // eslint-disable-next-line no-extend-native
    String.prototype.at = function stringAt(index: number) {
      const len = this.length
      const relativeIndex = index >= 0 ? index : len + index

      if (relativeIndex < 0 || relativeIndex >= len) {
        return undefined
      }

      return this[relativeIndex]
    }
  }
}

export {}
